import { useApolloClient } from '@apollo/client/react';
import { Formik } from 'formik';
import NewLinkInviteForm, { newLinkInviteSchema } from '../new-link-invite-form';
import type { Group } from '../../types/Group';
import { createGroupLinkInviteMutation, groupInvitesQuery } from '../../apollo/groups';

type Props = {
  group?: Group;
  disabled?: boolean;
};

const NewGroupLinkInvite = ({ group, disabled }: Props) => {
  const client = useApolloClient();
  return (
    <Formik
      initialValues={{}}
      validationSchema={newLinkInviteSchema}
      onSubmit={(values, actions) => {
        client.mutate({
          mutation: createGroupLinkInviteMutation,
          variables: { groupId: group.id },
          update: (proxy, { data: { createGroupLinkInvite: newInvite } }) => {
            const listVariables = { slug: group.slug };
            const data = proxy.readQuery({
              query: groupInvitesQuery,
              variables: listVariables
            })
            proxy.writeQuery({
              query: groupInvitesQuery,
              data: {
                ...data,
                group: {
                  ...data.group,
                  linkInvites: [newInvite, ...data.group.linkInvites]
                }
              },
              variables: listVariables
            })
          }
        }).then(() => {
          actions.setSubmitting(false);
          actions.resetForm();
        }).catch((error) => {
          actions.setSubmitting(false);
          console.log(error);
          // actions.setErrors();
          // actions.setStatus();
        });
      }}
    >
      <NewLinkInviteForm disabled={disabled} />
    </Formik>
  );
}

export default NewGroupLinkInvite;
